// Indicator field schemas + rule builders
export const INDICATORS = [
  {
    id: "RSI",
    label: "RSI",
    fields: [
      { name: "period", type: "number", default: 14, label: "Period" },
    ],
    ops: [">", "<", ">=", "<=", "cross_above", "cross_below"],
    valueMode: "number", // compare to number by default
  },
  {
    id: "MA",
    label: "SMA (Simple MA)",
    fields: [
      { name: "period", type: "number", default: 50, label: "Period" },
    ],
    ops: [">", "<", "cross_above", "cross_below"],
    valueMode: "price",
  },
  {
    id: "EMA",
    label: "EMA (Exponential MA)",
    fields: [
      { name: "period", type: "number", default: 20, label: "Period" },
    ],
    ops: [">", "<", "cross_above", "cross_below"],
    valueMode: "price",
  },
  {
    id: "MACD",
    label: "MACD",
    fields: [
      { name: "fast_ema", type: "number", default: 12, label: "Fast EMA" },
      { name: "slow_ema", type: "number", default: 26, label: "Slow EMA" },
      { name: "signal", type: "number", default: 9, label: "Signal" },
      { name: "mode", type: "select", default: "MODE_MAIN",
        options: ["MODE_MAIN","MODE_SIGNAL"], label: "Line" },
    ],
    ops: [">", "<", "cross_above", "cross_below"],
    valueMode: "number",
  },
  {
    id: "BOLLINGER",
    label: "Bollinger Bands",
    fields: [
      { name: "period", type: "number", default: 20, label: "Period" },
      { name: "deviation", type: "number", default: 2, label: "Deviation" },
      { name: "band", type: "select", default: "MODE_UPPER",
        options: ["MODE_UPPER","MODE_LOWER","MODE_MAIN"], label: "Band" },
    ],
    ops: [">", "<", "cross_above", "cross_below"],
    valueMode: "price",
  },
  {
    id: "STOCHASTIC",
    label: "Stochastic",
    fields: [
      { name: "k_period", type: "number", default: 5, label: "K Period" },
      { name: "d_period", type: "number", default: 3, label: "D Period" },
      { name: "slowing",  type: "number", default: 3, label: "Slowing" },
      { name: "mode",     type: "select", default: "MODE_MAIN",
        options: ["MODE_MAIN","MODE_SIGNAL"], label: "Line" },
    ],
    ops: [">", "<", "cross_above", "cross_below"],
    valueMode: "number",
  },
  {
    id: "ICHIMOKU",
    label: "Ichimoku Cloud",
    fields: [
      { name: "tenkan", type: "number", default: 9,  label: "Tenkan" },
      { name: "kijun",  type: "number", default: 26, label: "Kijun" },
      { name: "senkou", type: "number", default: 52, label: "Senkou" },
      { name: "line",   type: "select", default: "MODE_TENKANSEN",
        options: ["MODE_TENKANSEN","MODE_KIJUNSEN","MODE_SENKOUSPANA","MODE_SENKOUSPANB","MODE_CHIKOUSPAN"],
        label: "Line" },
    ],
    ops: [">", "<", "cross_above", "cross_below"],
    valueMode: "price",
  },
  {
    id: "ATR", label: "ATR",
    fields: [{ name:"period", type:"number", default:14, label:"Period" }],
    ops: [">", "<"], valueMode: "number",
  },
  {
    id: "ADX", label: "ADX",
    fields: [
      { name:"period", type:"number", default:14, label:"Period" },
      { name:"mode",   type:"select", default:"MODE_MAIN",
        options:["MODE_MAIN","MODE_PLUSDI","MODE_MINUSDI"], label:"Line" },
    ],
    ops: [">", "<"], valueMode: "number",
  },
  {
    id: "CCI", label: "CCI",
    fields: [{ name:"period", type:"number", default:14, label:"Period" }],
    ops: [">", "<"], valueMode: "number",
  },
];

export const TIMEFRAMES = [
  "PERIOD_M1","PERIOD_M5","PERIOD_M15","PERIOD_M30",
  "PERIOD_H1","PERIOD_H4","PERIOD_D1","PERIOD_W1","PERIOD_MN1"
];

export function findIndicator(id) {
  return INDICATORS.find((i) => i.id === id) || INDICATORS[0];
}

export function defaultRule(indicatorId, direction = "buy") {
  const ind = findIndicator(indicatorId);
  const rule = {
    _rid: (typeof crypto !== "undefined" && crypto.randomUUID) ? crypto.randomUUID() : `r_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
    indicator: ind.id,
    operator: ind.ops[0],
    direction,
  };
  ind.fields.forEach((f) => { rule[f.name] = f.default; });
  rule.applied_price = "PRICE_CLOSE";
  if (ind.valueMode === "number") rule.value = 50;
  else rule.reference = "price";
  return rule;
}
